<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="员工名称" prop="name">
                <a-input v-model="field.name" placeholder="请填写员工名称" />
            </a-form-model-item>
            <a-form-model-item label="员工角色" prop="role">
                <a-select v-model="field.role" placeholder="请选择员工角色">
                    <template v-for="(val, key) in $enums.UserRole">
                        <a-select-option :value="key" :key="key" v-if="key.startsWith('Plat')">
                            {{ val }}
                        </a-select-option>
                    </template>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="绑定码" prop="code" v-if="!field.id">
                <a-input v-model="field.code" placeholder="请填写绑定码" />
            </a-form-model-item>
            <a-form-model-item label="有效期（单位：小时）" prop="hour" v-if="!field.id">
                <a-input-number v-model="field.hour" :min="1" :max="360" suffix="小时" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                id: '',
                code: '',
                hour: 360,
                name: '',
                role: 'PlatAdmin'
            },
            rules: {
                name: [{ required: true, message: '请填写员工名称', trigger: 'blur' }],
                role: [{ required: true, message: '请选择员工角色', trigger: 'change' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        doSave() {
            if (!this.field.id) {
                if (!this.field.code) {
                    this.$message.error('请填写绑定码')
                    return
                }
                if (!this.field.hour) {
                    this.$message.error('请填写绑定码有效期')
                    return
                }
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/plat/emp/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
